import { twMerge } from "@/helpers/twMerge";
import PropTypes from "prop-types";

export const CouponDiscountIcon = ({ className }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden="true"
		focusable="false"
		className={twMerge(
			`tw:inline-block tw:h-[1em] tw:w-[1em] tw:shrink-0 tw:align-middle tw:leading-[1em]`,
			className,
		)}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M8.27 3a1 1 0 0 1 1 1v1.29h5.46V4a1 1 0 1 1 2 0v1.29h1.67c1.5 0 2.6 1.28 2.6 2.7v10.3c0 1.43-1.1 2.7-2.6 2.7H5.6A2.63 2.63 0 0 1 3 18.3V7.99c0-1.42 1.1-2.7 2.6-2.7h1.67V4a1 1 0 0 1 1-1Zm-.04 4.29H5.6c-.27 0-.6.25-.6.7v.72h14V8c0-.46-.33-.71-.6-.71h-2.63a1.02 1.02 0 0 1-.07 0H8.3a1.02 1.02 0 0 1-.07 0ZM19 10.7H5v7.58c0 .46.33.7.6.7h12.8c.27 0 .6-.24.6-.7V10.7Z"
			clipRule="evenodd"
		/>
	</svg>
);

CouponDiscountIcon.propTypes = {
	className: PropTypes.string,
};
